export * from './buscador-consignas-filter.component';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/buscador/buscador-consignas-filter/index.ts